const endpoints = {
  TRACKING: "documents/track"
}

export default endpoints;